// import { ThemeProps } from '@hhgtech/hhg-components'
import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  padding: 56px 0 36px 0;

  ${MediaQueries.mbDown} {
    justify-content: flex-start;
    align-items: flex-start;
    padding: 24px 0 24px 0;
  }
`

export const StyledRelationTool = styled.div`
  .stepper-wrapper {
    margin-top: auto;
    display: flex;
    justify-content: space-between;

    ${MediaQueries.mbDown} {
      flex-direction: column;
      gap: 24px;
    }
    margin-bottom: 20px;
  }
  .stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${MediaQueries.mbDown} {
      flex-direction: row;
    }
    flex: 1;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .stepper-item::before {
    position: absolute;
    content: '';
    z-index: 2;
  }

  .stepper-item::after {
    position: absolute;
    content: '';
    ${MediaQueries.mbUp} {
      border-bottom: 2px solid #e4e8ec;
      width: 100%;
      top: 20px;
      left: 50%;
    }
    ${MediaQueries.mbDown} {
      border-left: 2px solid #e4e8ec;
      width: 6%;
      height: 86px;
      top: 30px;
      left: 1.5%;
    }

    z-index: 2;
  }

  .stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;

    ${MediaQueries.mbDown} {
      height: 100%;
      justify-content: flex-start;
    }

    .logoTracking {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 12px;
      height: 12px;
      object-fit: contain;
    }
  }

  .stepper-item.active {
    font-weight: bold;
  }

  .stepper-item.completed::after {
    position: absolute;
    content: '';
    ${MediaQueries.mbUp} {
      border-bottom: 2px solid #e4e8ec;
      width: 100%;
      top: 20px;
      left: 50%;
    }
    ${MediaQueries.mbDown} {
      border-left: 2px solid #e4e8ec;
      width: 6%;
      height: 86px;
      top: 30px;
      left: 1.5%;
    }

    z-index: 3;
  }

  .stepper-item:first-of-type::before {
    content: none;
  }
  .stepper-item:last-child::after {
    content: none;
  }
`

export const StyledToolCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 80px;
    height: 80px;
    ${MediaQueries.mbDown} {
      width: 36px;
      height: 36px;
    }
  }

  ${MediaQueries.mbDown} {
    flex-direction: row;
    padding: 10px 16px;
    background: #ffffff;
    justify-content: flex-start;

    border: 1px solid #e4e8ec;
    box-sizing: border-box;

    box-shadow: 2px 2px 6px rgba(216, 228, 245, 0.75);
    border-radius: ${theme.borderRadius};
    width: 300px;
    left: 300%;

    &[data-type='active'] {
      background: #e3f2ff;
      opacity: 0.6;
      width: 300px;

      border: 1px solid #2d87f3;
    }
  }

  .logo {
    background: #ffffff;

    border: 1px solid #e4e8ec;
    box-shadow: 0px 2px 10px #e1edfe;
    border-radius: ${theme.borderRadius};
  }
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 16px;
    padding-left: 16px;

    ${MediaQueries.mbDown} {
      padding-top: 0;
    }

    h6 {
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      color: #262626;
    }
  }
  .title[data-type='active'] {
    h6 {
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      color: #bfbfbf;
    }
  }
`
